import { Box, IconButton, Tooltip } from '@chakra-ui/react';
import { Icons } from './Icons';
import { useTranslation } from 'react-i18next';

type Size = 'sm' | 'xs';

export function RemoveComponent({
  onClick,
  children,
  loading,
  size,
}: {
  onClick?: () => void;
  loading?: boolean;
  children: React.ReactNode;
  size?: Size;
}) {
  const { t } = useTranslation();

  if (!onClick) return <>{children}</>;

  return (
    <Box
      pos="relative"
      sx={{
        ':hover *[data-hover-id="remove"]': {
          opacity: 1,
          transform: 'scale(1)',
        },
      }}
    >
      {children}
      <Box
        pos="absolute"
        right={-2}
        top={-3}
        transition="transform 200ms ease, opacity 200ms ease"
        opacity={0}
        transform="scale(0.9)"
        data-hover-id="remove"
      >
        <Tooltip label={t('general.clickToRemove')}>
          <IconButton
            isLoading={loading}
            colorScheme="red"
            variant="solid"
            size={size ?? 'sm'}
            onClick={onClick}
            aria-label="remove"
            icon={<Icons.Close />}
          />
        </Tooltip>
      </Box>
    </Box>
  );
}
